import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const NavItem = ({ to, icon, label }) => (
    <Link to={to} className="nav-item">
        <div className="icon">{icon}</div>
        <p>{label}</p>
    </Link>
);

export default function TeacherDashboard() {
    return (
        <Layout>
            <Link to="/main" className="back-link">메인으로</Link>
            <h1 style={{ textAlign: 'center' }}>선생님 페이지</h1>
            <div className="nav-container">
                <NavItem to="/teacher/student-registration" icon="🎓" label="학생 등록" />
                <NavItem to="/teacher/book-registration" icon="📖" label="책 등록" />
                <NavItem to="/teacher/overall-status" icon="📈" label="전체 현황" />
                <NavItem to="/teacher/student-management" icon="👥" label="학생 관리" />
            </div>
        </Layout>
    );
}

